import { AdminMultiSelect, type MultiSelectItem } from "@/admin/AdminMultiSelect.tsx";
import { getPreferredLocation, type LocationWithEnabled } from "@/modules/location/location.ts";
import { usePricingLocations } from "@/modules/location/locationQuery.ts";
import { LocationSelectCustom } from "@/modules/location/LocationSelect.tsx";
import { useState } from "react";
import { Label } from "react-aria-components";

function AdminLocationSelect({ onChange }: { onChange: (value: LocationWithEnabled) => void }) {
    const locations = usePricingLocations();
    const location = getPreferredLocation(locations);
    const [selectedLocation, setSelectedLocation] = useState<LocationWithEnabled>(location);

    function onChangeLocation(location: LocationWithEnabled) {
        setSelectedLocation(location);
        onChange(location);
    }

    return (
        <div className="flex items-center">
            <Label className="font-size-small pr-1">Location:</Label>
            <LocationSelectCustom items={locations} value={selectedLocation} onChange={onChangeLocation} />
        </div>
    );
}

export interface AdminLocationMenuProps {
    value: string[];
    locations: LocationWithEnabled[];
    noLocationEnabled?: boolean;
    deletedLocations: string[];
    canUnselectAll?: boolean;
    onChange: (value: string[]) => void;
}

export function AdminLocationMenuContent({
    value,
    locations,
    noLocationEnabled,
    deletedLocations,
    onChange,
    canUnselectAll = true,
}: AdminLocationMenuProps) {
    const items: MultiSelectItem[] = [
        ...(noLocationEnabled ? [{ id: "", title: "No location" }] : []),
        ...locations.map((location) => ({
            id: location.slug,
            title: `${location.display_name} (${location.slug})`,
        })),
        ...(deletedLocations?.length
            ? deletedLocations.map((slug) => ({
                  id: slug,
                  title: `[deleted] (${slug})`,
              }))
            : []),
    ];

    return <AdminMultiSelect items={items} value={value} onChange={onChange} canUnselectAll={canUnselectAll} />;
}

export function AdminLocationMenu(props: AdminLocationMenuProps) {
    return (
        <div className="flex items-center">
            <Label className="font-size-small pr-1">Location:</Label>
            <AdminLocationMenuContent {...props} />
        </div>
    );
}
